import type { AalExportPayload, AalView } from "../aalV2";
import { useAalExport } from "../aalV2";

export type DownloadAALPromosPayload = AalExportPayload & {
  promo_type?: string;
  promo_status?: string;
  action_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  username?: string;
};

export const useDownloadAALPromosTable = (view: AalView) =>
  useAalExport("promos", view);
